<template>
  <div
    v-if="visible"
    ref="ref-popover"
    class="ref-popover"
    :class="[{ 'fade-in': visible }]"
  >
    <div :class="['ref-popover-detail', effect]">
      <!-- <div class="popover-detail-body" v-html="content"></div> -->
      <div ref="ref-popover-detail-body" class="ref-popover-detail-body"></div>
      <div class="triangle"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VPopover',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    effect: {
      type: String,
      default: 'dark'
    }
  }
}
</script>
<style lang="scss" scoped>
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  30% {
    opacity: 0.3;
  }
  60% {
    opacity: 0.6;
  }

  100% {
    opacity: 1;
  }
}
.fade-in {
  animation: fade-in 200ms ease-out both 1 /*infinite*/;
}
.ref-popover {
  position: absolute;
  z-index: 302;
  &-detail {
    padding: 8px 10px;
    background: rgba(34, 34, 34, 0.8);
    border-radius: 4px;
    position: relative;
    max-width: 500px;
    // pointer-events: none; //防止穿透
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
    &-body {
      // font-size: 12px;
      color: #ffffff;
      // line-height: 20px;
      text-align: justify;
    }
    .triangle {
      position: absolute;
      display: block;
      left: 10px;
      top: -6px;
      transform: translateY(-50%);
      width: 0px;
      height: 0px;
      content: '';
      border-color: transparent;
      border-style: solid;
      border-width: 6px;
      border-bottom: 6px solid rgba(34, 34, 34, 0.8);
      z-index: 220;
    }
    &.light {
      background: rgba(255, 255, 255, 0.8);
      .ref-popover-detail-body {
        color: #23262e;
      }
      .triangle {
        border-bottom: 6px solid rgba(255, 255, 255, 0.8);
      }
    }
  }
}
</style>
